import React, { useState } from "react";
import { Card, Row, Col, Button, Badge } from "react-bootstrap";
import { 
  CreditCard, 
  QrCode, 
  Download, 
  Printer, 
  Shield,
  Envelope,
  Telephone,
  GeoAlt,
  Droplet,
  Heart,
  Activity
} from "react-bootstrap-icons";
import gabonCoatOfArms from "../../assets/img/Coat_of_arms_of_Gabon.svg.png";
import cnamgsCover from "../../assets/img/cnamgs_cover.jpeg";
import { useAuth } from "../../contexts/AuthContext";

// Données fictives
const mockPatientData = {
  name: "MOUKITA ROXANNE ESTELLE",
  id: "608 762 681 2",
  birthDate: "28/08/1976",
  coverage: "80%",
  validUntil: "31/12/2026",
  phone: "+241 01 23 45 67",
  email: "roxanne.moukita@email.ga",
  address: "Libreville, Gabon",
  bloodType: "A+",
  doctor: "Dr. Nzogho",
  allergies: "Aucune",
  treatments: "Aucun",
  lastCheckup: "12/03/2025",
  photo: "https://randomuser.me/api/portraits/women/68.jpg"
};

const DigitalCard = () => {
  const { user } = useAuth();
  const [showQR, setShowQR] = useState(false);

  const patientInfo = {
    name: user?.name || mockPatientData.name,
    id: user?.id || mockPatientData.id,
    birthDate: user?.birthDate || mockPatientData.birthDate,
    coverage: user?.coverage || mockPatientData.coverage,
    validUntil: mockPatientData.validUntil,
    phone: mockPatientData.phone,
    email: user?.email || mockPatientData.email,
    address: mockPatientData.address,
    bloodType: mockPatientData.bloodType,
    doctor: mockPatientData.doctor,
    allergies: mockPatientData.allergies,
    treatments: mockPatientData.treatments,
    lastCheckup: mockPatientData.lastCheckup,
    photo: mockPatientData.photo
  };

  const gabonColors = {
    green: "#009E60",
    yellow: "#FCD116",
    blue: "#3A75C4"
  };

  return (
    <div className="" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="container-fluid">
        {/* En-tête */}
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><a href="/patient">Tableau de bord</a></li>
              <li className="breadcrumb-item active">Ma carte</li>
            </ol>
            <h4 className="main-title mb-0 d-flex align-items-center gap-2">
              <div className="bg-primary bg-opacity-10 rounded-circle p-2">
                <CreditCard className="text-primary" size={24} />
              </div>
              Carte d'Assurance Maladie
            </h4>
            <p className="text-muted mb-0 mt-1">
              Présentez votre carte chez tous les prestataires de santé partenaires
            </p>
          </div>
          <div className="d-flex gap-2">
            <Button variant="outline-primary" size="sm" className="rounded-pill px-3">
              <Download size={14} className="me-1" /> Télécharger
            </Button>
            <Button variant="outline-secondary" size="sm" className="rounded-pill px-3">
              <Printer size={14} className="me-1" /> Imprimer
            </Button>
          </div>
        </div>

        <Row className="g-4">
          {/* Carte principale */}
          <Col lg={7}>
            <Card className="border-0 shadow  bg-white" style={{ borderRadius: '20px', overflow: 'hidden', border: `1px solid ${gabonColors.yellow}60` }}>
              {/* Bandeau tricolore */}
              <div style={{
                height: '6px',
                background: `linear-gradient(90deg, ${gabonColors.green} 0%, ${gabonColors.green} 33%, ${gabonColors.yellow} 33%, ${gabonColors.yellow} 66%, ${gabonColors.blue} 66%, ${gabonColors.blue} 100%)`
              }}></div>
              
              <div className="card-header">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-3">
                    <div style={{
                      width: '55px',
                      height: '55px',
                      borderRadius: '50%',
                      background: `#dedede`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img src={gabonCoatOfArms} alt="Sceau" style={{ width: '38px', height: '38px' }} />
                    </div>
                    <div>
                      <div className="fw-bold" style={{ fontSize: '12px' }}>RÉPUBLIQUE GABONAISE</div>
                      <div className="text-muted" style={{ fontSize: '10px' }}>Union - Travail - Justice</div>
                    </div>
                  </div>
                  <div className="text-end">
                    <img src={cnamgsCover} alt="CNAMGS" style={{ height: '50px',borderRadius:'5px' }} />
                    {/* <div className="fw-bold" style={{ fontSize: '10px' }}>CNAMGS</div> */}
                  </div>
                </div>
              </div>
              <div style={{ padding: '1.5rem' }}>
                {/* En-tête avec logos */}
                

                {/* Section principale : Photo + Infos + QR Code */}
                <div className="d-flex gap-4">
                  {/* Photo */}
                  <div style={{
                    width: '100px',
                    height: '120px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    border: `2px solid ${gabonColors.yellow}`,
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                    flexShrink: 0
                  }}>
                    <img src={patientInfo.photo} alt="Photo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>

                  {/* Informations personnelles */}
                  <div className="flex-grow-1">
                    <div className="mb-2">
                      <div className="text-muted" style={{ fontSize: '10px' }}>NUMÉRO D'ASSURÉ</div>
                      <div className="fw-bold" style={{ fontSize: '18px', letterSpacing: '1px' }}>{patientInfo.id}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted" style={{ fontSize: '10px' }}>NOM - PRÉNOM</div>
                      <div className="fw-bold" style={{ fontSize: '16px' }}>{patientInfo.name}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted" style={{ fontSize: '10px' }}>DATE DE NAISSANCE</div>
                      <div style={{ fontSize: '14px' }}>{patientInfo.birthDate}</div>
                    </div>
                    <div className="d-flex gap-3 mt-2">
                      <div>
                        <div className="text-muted" style={{ fontSize: '9px' }}>Validité</div>
                        <div className="fw-bold" style={{ fontSize: '12px', color: gabonColors.blue }}>{patientInfo.validUntil}</div>
                      </div>
                      <div>
                        <div className="text-muted" style={{ fontSize: '9px' }}>Couverture</div>
                        <div className="fw-bold" style={{ fontSize: '13px', color: gabonColors.green }}>{patientInfo.coverage}</div>
                      </div>
                      <div>
                        <Badge className="rounded-pill px-2 py-1 bg-success " >
                          <span >●</span> Actif
                        </Badge>
                      </div>
                    </div>
                  </div>

                  {/* QR Code - À l'opposé de la photo */}
                  <div className="text-center" style={{ flexShrink: 0 }}>
                    <div 
                      className="bg-light d-flex align-items-center justify-content-center rounded"
                      style={{ 
                        width: '85px', 
                        height: '85px', 
                        cursor: 'pointer', 
                        border: `2px solid ${gabonColors.yellow}`,
                        transition: 'all 0.2s'
                      }}
                      onClick={() => setShowQR(!showQR)}
                    >
                      <QrCode size={48} style={{ color: gabonColors.blue }} />
                    </div>
                    <div className="mt-2">
                      <div className="fw-semibold" style={{ fontSize: '11px' }}>QR Code</div>
                      <div className="text-muted" style={{ fontSize: '9px' }}>
                        {showQR ? "Masquer" : "Afficher"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Zone QR Code étendu */}
                {showQR && (
                  <div className="mt-3 pt-3 border-top text-center">
                    <div className="bg-light p-3 rounded d-inline-block" style={{ border: `1px solid ${gabonColors.yellow}` }}>
                      <QrCode size={100} style={{ color: gabonColors.blue }} />
                    </div>
                    <div className="text-muted mt-2" style={{ fontSize: '10px' }}>
                      Scannez ce code chez votre médecin ou pharmacien
                    </div>
                  </div>
                )}

                {/* Éléments de sécurité */}
                
              </div>

              <div className="card-footer mt-3 d-flex justify-content-end gap-2 bg-primary">
                  <div style={{ width: '25px', height: '25px', background: '#f0f0f0', borderRadius: '50%' }}></div>
                  <div style={{ width: '25px', height: '25px', background: '#f0f0f0', borderRadius: '50%' }}></div>
                  <div style={{ width: '25px', height: '25px', background: '#f0f0f0', borderRadius: '50%' }}></div>
                </div>
            </Card>
          </Col>

          {/* Colonne droite - Informations */}
          <Col lg={5}>
            {/* Coordonnées */}
            <Card className="border-0 shadow mb-3 bg-white" style={{ borderRadius: '16px' }}>
              <div style={{ padding: '1rem 1.2rem' }}>
                <h6 className="fw-bold mb-3 d-flex align-items-center gap-2">
                  <Envelope size={16} style={{ color: gabonColors.blue }} />
                  Coordonnées
                </h6>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <Envelope size={14} className="text-muted" />
                  <span>{patientInfo.email}</span>
                </div>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <Telephone size={14} className="text-muted" />
                  <span>{patientInfo.phone}</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <GeoAlt size={14} className="text-muted" />
                  <span>{patientInfo.address}</span>
                </div>
              </div>
            </Card>

            {/* Informations médicales */}
            <Card className="border-0 shadow mb-3 bg-white" style={{ borderRadius: '16px' }}>
              <div style={{ padding: '1rem 1.2rem' }}>
                <h6 className="fw-bold mb-3 d-flex align-items-center gap-2">
                  <Heart size={16} style={{ color: gabonColors.green }} />
                  Informations médicales
                </h6>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="text-muted">Groupe sanguin</span>
                  <Badge className="rounded-pill px-3 py-2" >
                    <Droplet size={12} className="me-1" /> {patientInfo.bloodType}
                  </Badge>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="text-muted">Médecin traitant</span>
                  <span className="fw-medium">{patientInfo.doctor}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-muted">Allergies</span>
                  <Badge className="rounded-pill px-3 py-2 bg-warning">
                    {patientInfo.allergies}
                  </Badge>
                </div>
              </div>
            </Card>

            {/* Activité récente */}
            <Card className="border-0 shadow bg-white" style={{ borderRadius: '16px' }}>
              <div style={{ padding: '1rem 1.2rem' }}>
                <h6 className="fw-bold mb-3 d-flex align-items-center gap-2">
                  <Activity size={16} style={{ color: gabonColors.yellow }} />
                  Activité récente
                </h6>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted">Dernière consultation</span>
                  <span className="fw-medium">{patientInfo.lastCheckup}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted">Date d'adhésion</span>
                  <span className="fw-medium">01/01/2024</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-muted">Total consultations</span>
                  <Badge className="rounded-pill px-3 py-2 bg-success" >
                    12 consultations
                  </Badge>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
<br></br><br></br>
        <style>{`
          .card {
            border-radius: 20px !important;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .card:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08) !important;
          }
        `}</style>
      </div>
    </div>
  );
};

export default DigitalCard;